import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCk8SPgcElHirudMuc445bnZjyk_GjDF1k",
  authDomain: "polani-2c215.firebaseapp.com",
  projectId: "polani-2c215",
  storageBucket: "polani-2c215.firebasestorage.app",
  messagingSenderId: "1077104026951",
  appId: "1:1077104026951:web:df96b41f0338f0c1599862",
  measurementId: "G-GFNKMZJWP5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
